import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { VisibilityBlankDark } from 'src/shared/features/visibility/assets/visibility-blank-dark'
import { VisibilityDark } from 'src/shared/features/visibility/assets/visibility-dark'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

const VisibilityBadge = () => {
  const { data: user } = useMyUserData()
  const isMobile = useIsMobile()

  if (!user || user.profileComplete < 100) {
    return (
      <Link to={paths.users.completeProfile.getHref()} className="flex items-center gap-1">
        <VisibilityDark className="size-10" />
        <div className="flex flex-col">
          <span className={cn('font-bold', isMobile ? 'text-sm' : 'text-lg')}>Unlock Visibility</span>
          <p className="text-xs text-muted">Complete profile</p>
        </div>
      </Link>
    )
  }

  const score = user.visibilityScore || 1

  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        <VisibilityBlankDark className="size-10" />
        <span className="absolute left-1/2 top-[22px] -translate-x-1/2 -translate-y-1/2 font-bold text-primary-foreground">
          {score}
        </span>
      </div>
      <span className="text-lg font-medium">Visibility</span>
    </div>
  )
}

export default VisibilityBadge
